<template>
    <div>
        <div class="heading">
            <div class="heading-left">
                <h4>Status</h4>
            </div>
            <div class="heading-right">
                <div class="ml-auto">
                    <div class="temp text-right">{{battStatus}}%
                        <w-icon width="13px" alt="battery" name="battery" :type="batteryImg(battStatus)"/>
                    </div>
                    <span class="info">WaterGuru Battery</span>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="line" v-for="ref in refs" :key="ref.type">
                <div class="name">{{ref.label}}</div>
                <div class="bar">
                    <div class="bar-info">{{ref.timeLeftText}}</div>
                    <div class="progress">
                        <div class="progress-bar" :style="{backgroundColor: ref.color, width: ref.pctLeft + '%'}"></div>
                    </div>
                </div>
                <div class="action">
                    <drop-down-menu :open="showDropDown === ref.type" @close="showDropDown = false">
                        <template slot="trigger">
                            <w-button class="action-btn" :disabled="true" v-if="ref.pctLeft === 100 || (senseOnly && ref.type !== 'LAB')">
                                <template v-if="ref.type === 'LAB'">Replaced</template>
                                <template v-else>Full</template>
                            </w-button>
                            <w-button class="action-btn" v-else @click="showDropDown = ref.type">
                                <template v-if="ref.type === 'LAB'">Replace</template>
                                <template v-else>Refill</template>
                            </w-button>
                        </template>
                        <template slot="content">
                            <chlorine v-if="ref.type === 'CL_RES' && showDropDown === 'CL_RES'" @update="showDropDown = false;getPools()"/>
                            <balancer v-if="ref.type === 'PH_RES' && showDropDown === 'PH_RES'" @update="showDropDown = false;getPools()"/>
                            <cassette v-if="ref.type === 'LAB' && showDropDown === 'LAB'" @update="showDropDown = false;getPools()"/>
                        </template>
                    </drop-down-menu>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DropDownMenu from './dropdown-menu'
import Chlorine from './dropdown-menu/Chlorine'
import Balancer from './dropdown-menu/Balancer'
import Cassette from './dropdown-menu/Cassette'

export default {
    name: 'Status',
    data () {
        return {
            showDropDown: false
        }
    },
    components: {
        DropDownMenu,
        Chlorine,
        Balancer,
        Cassette
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool',
            senseOnly: 'pools/senseOnly'
        }),
        refs () {
            if (!this.pool) return []
            return this.pool.pods[0].refillables.filter(item => item.type !== 'BATT')
        },
        battStatus () {
            if (!this.pool) return 0
            const ref = this.pool.pods[0].refillables.find(item => item.type === 'BATT')
            return ref ? ref.pctLeft : 0
        }
    },
    methods: {
        ...mapActions({
            getPools: 'pools/getPools'
        }),
        batteryImg (left) {
            if (left >= 87.5) return 4
            else if (left <= 87.5 && left > 62.5) return 3
            else if (left <= 62.5 && left > 37.5) return 2
            else if (left <= 37.5 && left > 17.5) return 1
            else return 0
        }

    }
}
</script>

<style scoped lang="scss">
    .heading {
        display: flex;
        margin-bottom: 13px;
    }

    .heading-left {
        flex-grow: 1;
    }

    .heading-right {
        display: flex;
        justify-content: space-between;
    }

    h4 {
        font-size: 40px;
        font-weight: 300;
        margin-bottom: 0;
    }

    .info {
        font-size: 12px;
        color: #7B8C9F;
    }

    .temp {
        font-size: 20px;
        font-weight: 300;
    }

    .body {
        margin-left: 35px;
    }

    .line {
        display: flex;
        align-items: flex-end;
        margin-bottom: 40px;
    }

    .name {
        width: 20%;
        font-size: 20px;
        font-weight: 600;
        line-height: 14px;
    }

    .bar {
        width: 60%;
        padding-right: 9px;
    }

    .action {
        width: 20%;
        text-align: right;
    }

    .progress {
        height: 7px;
    }

    .action-btn {
        width: 100%;
    }

    @media (max-width: 1024px) {
        .heading {
        h4 {
            font-size: 30px;
            font-weight: 600;
        }

        .info {
            font-size: 9px;
        }
    }
    }

    @media (max-width: 768px) {
        .body {
            margin-left: 0;
        }

        h4 {
            font-size: 22px;
            font-weight: 600;
        }

        .progress {
            height: 4px;
        }

        .info {
            font-size: 9px;
        }

        .name {
            width: 29%;
            font-size: 14px;
        }

        .bar {
            width: 40%;
            padding-right: 9px;
        }

        .bar-info {
            font-size: 12px;
        }

        .action {
            width: 35%;
            text-align: right;
        }

        .action-btn {
            font-size: 14px !important;
        }
    }
</style>
